import blog1 from '../../../Assets/Cards/1Blog.png';
import blog2 from '../../../Assets/Cards/2Blog.png';
import blog3 from '../../../Assets/Cards/blogcard5.png';
import blog4 from '../../../Assets/Cards/blogcard6.png';
export const blogs1Data=[
    {
        image:blog3,
        sub:"collaboration",
        title:"Our customers range from Fortune 100 companies, to startups and schools - all using our online…",
        by:"natalie coy"
     },
     {
         image:blog4,
         sub:"design",
         title:"Our customers range from Fortune 100 companies, to startups and schools - all using our online…",
         by:"eli woolery"
      },
    ]